module.exports = __webpack_public_path__ + "img/collaborate_20.05f2fab9.jpg";